import React, { useState, useEffect, useRef } from "react";
import { ItemContainer } from "./index.styled";

interface CampaignSummaryItemProps {
  label: string;
  value: number;
  maxValue: number;
}

const CampaignSummaryItem: React.FC<CampaignSummaryItemProps> = ({
  label,
  value,
  maxValue,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const progressRef = useRef<HTMLDivElement>(null);
  const progressPercentage = (value / maxValue) * 100;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (progressRef.current) {
      observer.observe(progressRef.current);
    }

    return () => {
      if (progressRef.current) {
        observer.unobserve(progressRef.current);
      }
    };
  }, []);

  return (
    <ItemContainer>
      <div className="option-header">
        <div className="option-title">{label}</div>
        <div className="option-value">{value}</div>
      </div>
      <div className="option-content">
        <div className="progress-bar" ref={progressRef}>
          <div
            className={`progress-fill ${isVisible ? "animate" : ""}`}
            style={
              {
                width: isVisible ? `${progressPercentage}%` : "0%",
                "--progress-width": `${progressPercentage}%`,
              } as React.CSSProperties
            }
          />
        </div>
      </div>
    </ItemContainer>
  );
};

export default CampaignSummaryItem;
